import React from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import Process from './components/Process';
import Testimonials from './components/Testimonials';
import Team from './components/Team';
import Contact from './components/Contact';
import Footer from './components/Footer';
import { Route, Routes } from 'react-router-dom';
import Taller from './pages/Taller';
import PoliticaPrivacidad from './pages/politicaPrivacidad';
import TerminosServicios from './pages/TerminosServicios';

function App() {
  return (
    <div className="min-h-screen bg-white antialiased text-slate-800 font-sans selection:bg-blue-100">
      <Header />
      <main>
        <Routes>
          {/* PÁGINA PRINCIPAL */}
          <Route path="/" element={
            <>
              <Hero />
              <Services />
              <Process />
              <Testimonials />
            </>
          } />

          {/* PÁGINAS DE DETALLES DE CADA SERVICIO */}
          <Route path="/servicios/:slug" element={<Taller />} />

          <Route path="/terminos-y-condiciones" element={<TerminosServicios />} />
          <Route path="/politica-privacidad" element={<PoliticaPrivacidad />} />


        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default App;